import Image from 'next/image';

import { IStory } from 'types/story';

import { formatDate, formatDateTime } from 'services/date';
import { getFullName, getInitials } from 'services/user';

interface IProps {
  story: IStory;
  showAuthor?: boolean;
  views?: number;
}
export const StoryTileHeader = ({
  story,
  showAuthor = true,
  views,
}: IProps) => {
  return (
    <div className="flex w-full basis-full flex-row items-center justify-start overflow-hidden whitespace-nowrap pb-3">
      {story.author && (
        <>
          <div className="mr-2 flex h-[30px] w-[30px] flex-shrink-0 items-center justify-center overflow-hidden rounded-full bg-grey/20 dark:bg-grey/30">
            {story.author.avatar && (
              <Image
                src={story.author.avatar}
                alt={`${story.author.firstName}'s avatar`}
                width={30}
                height={30}
                loading="eager"
              />
            )}

            <span
              className="absolute -z-10 text-[11px]"
              title={getFullName(story.author)}
            >
              {getInitials(story.author)}
            </span>
          </div>

          {showAuthor && (
            <div className="hidden w-[1px] flex-grow flex-col justify-center overflow-hidden pr-2 sm:flex">
              <p className="overflow-hidden text-ellipsis text-xs font-bold text-mineShaftGrey dark:text-white">
                {`${story.author.firstName} ${story.author.lastName}`}
              </p>

              {story.author.job && (
                <span className="overflow-hidden text-ellipsis text-[10px] text-black/50 dark:text-white dark:text-opacity-50">
                  {story.author.job}
                </span>
              )}
            </div>
          )}
        </>
      )}

      <div className="ml-auto flex flex-shrink-0 flex-col items-end justify-end">
        <time className="text-[10px] text-black/50 dark:text-white/50">
          {getPublishLabel(story)}
        </time>

        {views ? (
          <span className="text-[10px] text-black/50 dark:text-white/50">
            {views} {views === 1 ? 'view' : 'views'}
          </span>
        ) : null}
      </div>
    </div>
  );
};

function getPublishLabel(story: IStory): string {
  if (story.meta.scheduledPublishAt) {
    return `Scheduled for ${formatDateTime(story.meta.scheduledPublishAt)}`;
  }
  if (story.meta.publishedAt) {
    return formatDate(story.meta.publishedAt);
  }
  return 'Unpublished';
}
